import React, {Component} from 'react';
import {
    Grid,
    Paper,
    Typography
} from 'material-ui';
import {getDisplayNameOrNull} from '../../components/helpers/helpers';
import {BackButton} from '../../components/buttons/BackButton';

class TagViewContent extends Component {

    render() {
        const {
            tag,
            classes
        } = this.props;

        return (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <div className={classes.tagViewHeading}>
                        <p className={classes.tagViewLead}>View details for "{tag.display_name}"</p>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={2} className={classes.tagViewContent}>
                        <Grid container spacing={24}>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Tagos ID:
                                    <p className={classes.tagContentParagraph}>{getDisplayNameOrNull(tag.tagos_id)}</p>
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={6} xs={12}>
                                <Typography variant="subheading">Name:
                                    <p className={classes.tagContentParagraph}>{getDisplayNameOrNull(tag.display_name)}</p>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.buttons}>
                        <BackButton
                            link={"/tags"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default TagViewContent;



// WEBPACK FOOTER //
// ./src/containers/tags/TagViewContent.jsx